class Sale {
    constructor() {
        this.id = null
        this.external_id = ''
        this.branch = ''
        this.product = ''
        this.channel = ''
        this.quantity = ''
        this.cost = ''
        this.price = ''
        this.cash_price = ''
        this.datetime_created = ''
        this.datetime_updated = ''
    }

    static get fieldNames() {
        return {
            id: 'ID',
            external_id: 'ID Externo',
            branch: 'Filial',
            product: 'Produto',
            channel: 'Canal',
            quantity: 'Quantidade',
            cost: 'Custo',
            price: 'Preço',
            cash_price: 'Preço a Vista',
            datetime_created: 'Data de Criação',
            datetime_updated: 'Data de Atualização'
        }
    }

    static get fieldTypes() {
        return {
            id: 'number',
            external_id: 'text',
            branch: 'number',
            product: 'number',
            channel: 'text',
            quantity: 'number',
            cost: 'number',
            price: 'number',
            cash_price: 'number',
            datetime_created: 'datetime-local',
            datetime_updated: 'datetime-local'
        }
    }

    static get visibleFields() {
        return {
            id: true,
            external_id: true,
            branch: true,
            product: true,
            channel: true,
            quantity: true,
            cost: true,
            price: true,
            cash_price: true,
            datetime_created: false,
            datetime_updated: false
        }
    }

    static get editableFields() {
        return {
            // id: false, // omit false
            external_id: true,
            branch: true,
            product: true,
            channel: true,
            quantity: true,
            cost: true,
            price: true,
            cash_price: true
            // datetime_created: false
        }
    }
}

export default Sale

export { Sale }
